import { FormFieldTransform } from '@unistocks/components/form/model';
import { CurrencyDto } from '@unistocks/proxy/axios-client';
import { t } from '@unistocks/shared/localization/index.ts';
import { arrayify, createDate, isDefined, isNumber, isString } from '@unistocks/shared/utils/util';

/**
 * Transform function for select fields
 * Converts select value to an array
 */
export const arrayTransform: FormFieldTransform<any, any> = {
  // input: value => value,
  output: value => (isDefined(value) ? arrayify(value) : [])
};

export const currencyTransform: FormFieldTransform<CurrencyDto, string> = {
  input: value => value?.code ?? null,
  output: value => (value ? { code: value, displayName: t(`::Currency:${value}`) } : null)
};

export const dateTransform: FormFieldTransform<string, Date> = {
  input: value => (value ? new Date(value) : null),
  output: value => (value ? createDate(value).toISODate() : null)
};

export const percentageTransform: FormFieldTransform<number, string | number> = {
  input: value => (isNumber(value) ? (value * 100).toString() : value) ?? null,
  output: value => {
    let transformedValue: any = value;
    if (value && isString(value)) {
      transformedValue = Number(value.replace(',', '.'));
    }
    if (isNumber(transformedValue)) {
      transformedValue /= 100;
    }

    return transformedValue ?? null;
  }
};
